module.exports = __webpack_public_path__ + "media/images/emblems/Hochwald-blason-19e4d241a259ca4a27c803e6fd4cbddd.png";